export default "__VITE_ASSET__DKnq8Oja__"